export class AssessmentCriteria {
    public id: number;
    public beoordelingsvorm: string;
    public beoordelingsvormId: number;
    public label: string;
    public cruciaal: string;
    public toelichting: string;
    public toelichtingPagina: number;
    public geselecteerdeWaarde: number;
}



// WEBPACK FOOTER //
// ./src/app/examination/workprocess/assessment-criteria.ts